import React, {useState, useEffect} from 'react';

export interface Version {
	Version: string;
	DomainCount: number;
	Highlight?: boolean;
	Vulnerable?: boolean;
}

interface VersionDistributionChartProps {
	title?: string;
	subtitle?: string;
	versions: Version[];
	totalCount?: number;
	google?: wts_approved_any;
}

// interface ChartProps {
// 	title?: string;
// 	subtitle?: string;
// 	versions?: Version[];
// 	name?: string;
// }

function AddDataRow(data: any, version: Version, stroke: number): void {
	let colorDefault: string = 'stroke-color: #15387D; stroke-width: ' + stroke +'; fill-color: #2057C2';
	let colorCVE: string = 'stroke-color: #A1152B; stroke-width: ' + stroke +'; fill-color: #ED1F3F';
	let colorHighlight: string = 'stroke-color: #2DB881; stroke-width: ' + stroke +'; fill-color: #1D7552';
	
	if (version.Highlight)
	{
		data.push(['v' + String(version.Version), Number(version.DomainCount), colorHighlight]);
	}							
	else if (version.Vulnerable)
	{
		// vuln color
		data.push(['v' + String(version.Version), Number(version.DomainCount), colorCVE]);
	}
	else
	{
		// default color
		data.push(['v' + String(version.Version), Number(version.DomainCount), colorDefault]);
	}
}

export default function VersionDistributionChart({title, subtitle, versions, totalCount, google}: VersionDistributionChartProps) {

	if (!versions) return null;
	if (!google) return null;

	const [chart, setChart] = useState<wts_approved_any>(null);

	useEffect(() => {
		if (google && !chart && versions) {

			// Create the data table.
			var data: wts_approved_any = new google.visualization.DataTable();
			data.addColumn('string','Version');
			data.addColumn('number','Websites');
			data.addColumn({type:'string', role:'style'})

			if (!versions) return;

			let stroke: number = 4;
			if (versions.length > 200) {
				stroke = 1;
			} else if (versions.length > 60) {
				stroke = 2;
			}
			//let colorDefault = 'stroke-color: #703593; stroke-width: ' + stroke +'; fill-color: #C5A5CF';
			let colorDefault: string = 'stroke-color: #15387D; stroke-width: ' + stroke +'; fill-color: #2057C2';
			let colorCVE: string = 'stroke-color: #A1152B; stroke-width: ' + stroke +'; fill-color: #ED1F3F';
			let colorHighlight: string = 'stroke-color: #2DB881; stroke-width: ' + stroke +'; fill-color: #1D7552';

			// dont know how to create a good mathematic algorithm
			// so just going to hardcode some values
			let noise: number = 0;
			
			let totalDomainCount: number = totalCount || 0;
			if (!totalDomainCount) {
				totalDomainCount = 0;
				versions.map((version: Version) => {
					totalDomainCount += version.DomainCount;
				})					
			} 
		
			noise = totalDomainCount / (10 * versions.length);

			versions.map((version: Version) => {
				if (version.Highlight || version.DomainCount > noise) {
					if (version.Highlight)
					{
						data.addRow(['v' + String(version.Version), Number(version.DomainCount), colorHighlight]);
					}							
					else if (version.Vulnerable)
					{
						// vuln color
						data.addRow(['v' + String(version.Version), Number(version.DomainCount), colorCVE]);
					}
					else
					{
						// default color
						data.addRow(['v' + String(version.Version), Number(version.DomainCount), colorDefault]);
					}
				}
			})				
			// Set chart options
			let chartTitle: string = title ? `${title} versions distribution` : '';
			var options: wts_approved_any = {
				'title': chartTitle,
				'legend': 'none',
				'stroke-color': '#703593',
				'stroke-width': 4,
				'fill-color': '#C5A5CF',
				hAxis: {
					title: 'Versions',
					direction: '-1'				
				},
				vAxis: {
					scaleType: 'log',
					title: 'Websites',
					minValue: 0

				}
			};
			// Instantiate and draw our chart, passing in some options.
			const newChart: wts_approved_any = new google.visualization.ColumnChart(document.getElementById('versions_distr_div'));
			newChart.draw(data, options);

			setChart(newChart);							
		}		
	}, [google, chart, versions, title, totalCount])


	if (title === undefined) {
		return (			
			<div 
				id="versions_distr_div" 
				style={{width: '100%'}}     
			>	
			</div>
		)
	} else {
		return (
			<>
				<h3 className="text-left">{title}</h3>
				{subtitle}
				<br />
				<br />
				<div 
					id="versions_distr_div" 
					style={{width: '100%'}}
				>
				</div>
			</>
		)		
	}

}
